import { useState } from "react";
import { Tabs } from "antd";
import Salary from "../components/Salary";
import User from "../components/User";

const UserPage = () => {
  const [activeTab, setActiveTab] = useState("1");

  const items = [
    { key: "1", label: "Users", children: <User /> },
    { key: "2", label: "Salary", children: <Salary /> },
  ];

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        items={items}
        style={{ height: "100%" }}
        tabBarStyle={{ marginBottom: 0 }}
      />
    </div>
  );
};

export default UserPage;
